import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader } from "../../../components";
import {
  Box,
  Typography,
  Button,
  Divider,
  Snackbar,
  Alert,
  Paper,
  Card,
  CardHeader,
  CardActionArea,
  CardMedia,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import { KeyOffRounded } from "@mui/icons-material";
import { Col, Row, Form } from "react-bootstrap";
import firebase from "firebase/compat/app";
import "firebase/compat/storage";

const TambahRegisterSurvey = () => {
  const { user } = useContext(AuthContext);
  const { dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [kodeRegisterSurvey, setKodeRegisterSurvey] = useState("");
  const [namaRegisterSurvey, setNamaRegisterSurvey] = useState("");
  const [almRegisterSurvey, setAlmRegisterSurvey] = useState("");
  const [nopolRegisterSurvey, setNopolRegisterSurvey] = useState("");

  let [gambar, setGambar] = useState([]);
  let [arrayImage, setArrayImage] = useState([]);
  let [arrayImageUrl, setArrayImageUrl] = useState([]);
  let arrayImageSubmitted = [];
  const [invalidImage, setinvalidImage] = useState(null);
  const [cameraActive, setCameraActive] = useState(false);
  const [cameraError, setCameraError] = useState("");
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [validated, setValidated] = useState(false);
  const { screenSize } = useStateContext();
  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getNextKodeRegisterSurvey();
  }, []);

  useEffect(() => {
    getUrlImg();
  }, [arrayImage]);

  useEffect(() => {
    return () => {
      stopCamera(false);
    };
  }, []);

  const getUrlImg = () => {
    let tempArrayImageUrl = [];
    Object.keys(arrayImage).map(function (key, index) {
      tempArrayImageUrl.push(URL.createObjectURL(arrayImage[key]));
      setArrayImageUrl(tempArrayImageUrl);
    });
  };

  const getNextKodeRegisterSurvey = async () => {
    setLoading(true);
    const nextKodeRegisterSurvey = await axios.post(
      `${tempUrl}/registerSurveysNextKode`,
      {
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      },
    );
    setKodeRegisterSurvey(nextKodeRegisterSurvey.data);
    setLoading(false);
  };

  const startCamera = async () => {
    try {
      setCameraError("");

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setCameraError("Browser tidak mendukung akses kamera.");
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: "environment" },
        },
        audio: false,
      });

      streamRef.current = stream;

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
      }

      setCameraActive(true);
    } catch (error) {
      setCameraError(
        "Kamera tidak bisa dibuka. Pastikan izin kamera diberikan.",
      );
      console.log(error);
    }
  };

  const stopCamera = (updateState = true) => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }

    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }

    if (updateState) {
      setCameraActive(false);
    }
  };

  const capturePhoto = () => {
    if (!videoRef.current || !canvasRef.current) {
      return;
    }

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const width = video.videoWidth;
    const height = video.videoHeight;

    if (!width || !height) {
      setCameraError("Kamera belum siap. Coba ambil foto sekali lagi.");
      return;
    }

    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(video, 0, 0, width, height);

    canvas.toBlob(
      (blob) => {
        if (!blob) {
          setCameraError("Foto gagal diambil. Coba ulangi.");
          return;
        }

        const fileName = `register-survey-${Date.now()}.jpg`;
        const capturedFile = new File([blob], fileName, {
          type: "image/jpeg",
          lastModified: Date.now(),
        });

        setArrayImage((prevArrayImage) => [...prevArrayImage, capturedFile]);
        setCameraError("");
      },
      "image/jpeg",
      0.9,
    );
  };

  const saveRegisterSurvey = async (e) => {
    e.preventDefault();
    var date = new Date();
    var current_date =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    var current_time =
      date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

    let isFailedValidation =
      namaRegisterSurvey.length === 0 ||
      almRegisterSurvey.length === 0 ||
      nopolRegisterSurvey.length === 0;

    if (isFailedValidation) {
      setError(true);
      setOpen(!open);
    } else {
      try {
        setLoading(true);

        let savedRegisterSurvey = await axios.post(
          `${tempUrl}/saveRegisterSurvey`,
          {
            namaRegisterSurvey,
            almRegisterSurvey,
            nopolRegisterSurvey,
            tglInput: current_date,
            jamInput: current_time,
            userInput: user.username,
            kodeCabang: user.cabang._id,
            id: user._id,
            token: user.token,
          },
        );
        console.log("savedRegisterSurvey.data._id");
        console.log(savedRegisterSurvey.data._id);
        let registerSurveyId = savedRegisterSurvey.data._id;

        const selectedImages = Array.from(arrayImage).filter(
          (selectedFile) => selectedFile,
        );

        const uploadedImageUrls = await Promise.all(
          selectedImages.map(async (selectedFile) => {
            const storageRef = firebase.storage().ref();
            const fileRef = storageRef.child(
              `${Date.now()}-${Math.floor(
                Math.random() * 1000 + 1,
              )}-${selectedFile.name}`,
            );
            const snapshot = await fileRef.put(selectedFile);
            return snapshot.ref.getDownloadURL();
          }),
        );

        arrayImageSubmitted = [...gambar, ...uploadedImageUrls];

        await axios.post(
          `${tempUrl}/uploadFotoRegisterSurvey/${registerSurveyId}`,
          {
            gambar: arrayImageSubmitted,
            id: user._id,
            token: user.token,
            kodeCabang: user.cabang._id,
          },
        );

        setLoading(false);
        navigate("/registerSurvey");
      } catch (error) {
        setLoading(false);
        console.log("error");
        console.log(error);

        if (error.response?.status == 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        }
        console.log(error);
      }
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Box>
      <Typography color="#757575">Master</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Tambah Register Survey Penjualan
      </Typography>
      <Divider sx={dividerStyle} />
      <Paper sx={contentContainer} elevation={12}>
        <Form noValidate validated={validated} onSubmit={saveRegisterSurvey}>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Kode :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={kodeRegisterSurvey} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nama <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={namaRegisterSurvey}
                        required
                        onChange={(e) =>
                          setNamaRegisterSurvey(e.target.value.toUpperCase())
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        Nama harus diisi!
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Alamat <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={almRegisterSurvey}
                        required
                        onChange={(e) =>
                          setAlmRegisterSurvey(e.target.value.toUpperCase())
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        Alamat harus diisi!
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nopol <b style={colorRed}>*</b> :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control
                        value={nopolRegisterSurvey}
                        required
                        onChange={(e) =>
                          setNopolRegisterSurvey(e.target.value.toUpperCase())
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        Nopol harus diisi!
                      </Form.Control.Feedback>
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}></Box>
          </Box>

          {/* Data Gambar (Input) */}
          <Paper elevation={6} sx={mainContainer}>
            <Typography variant="h5" sx={titleStyle} color="primary">
              UPLOAD FOTO
            </Typography>
            <Box sx={showDataContainer}>
              <Box sx={showDataWrapper}>
                {invalidImage !== null ? (
                  <h4 className="error"> {invalidImage} </h4>
                ) : null}
                <label className="text-white">Ambil Foto :</label>
                {cameraError ? (
                  <h4 className="error"> {cameraError} </h4>
                ) : null}
                <Box sx={cameraContainer}>
                  <video
                    ref={videoRef}
                    playsInline
                    muted
                    style={{
                      ...cameraPreview,
                      display: cameraActive ? "block" : "none",
                    }}
                  />
                  <canvas ref={canvasRef} style={{ display: "none" }} />
                </Box>
                <Box sx={cameraButtonContainer}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={startCamera}
                    endIcon={<CameraAltIcon />}
                    disabled={cameraActive}
                  >
                    Buka Kamera
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    color="success"
                    onClick={capturePhoto}
                    endIcon={<AddAPhotoIcon />}
                    disabled={!cameraActive}
                  >
                    Ambil Foto
                  </Button>
                  <Button
                    type="button"
                    variant="outlined"
                    color="secondary"
                    onClick={stopCamera}
                    endIcon={<StopCircleIcon />}
                    disabled={!cameraActive}
                  >
                    Tutup Kamera
                  </Button>
                </Box>
              </Box>
            </Box>
            <Box sx={listImageContainer}>
              {arrayImageUrl &&
                arrayImage &&
                arrayImageUrl.map((key, i) => (
                  <Card sx={imageCard} elevation={10}>
                    <CardActionArea>
                      <CardHeader title={`Gambar`} subheader={`No. ${i + 1}`} />
                      <CardMedia
                        component="img"
                        height="200px"
                        src={key}
                        alt={KeyOffRounded.name}
                      />
                    </CardActionArea>
                  </Card>
                ))}
            </Box>
          </Paper>

          <Box sx={spacingTop}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => navigate("/registerSurvey")}
              sx={{ marginRight: 2 }}
            >
              {"< Kembali"}
            </Button>
            <Button variant="contained" startIcon={<SaveIcon />} type="submit">
              Simpan
            </Button>
          </Box>
        </Form>
      </Paper>
      <Divider sx={spacingTop} />
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Box>
  );
};

export default TambahRegisterSurvey;

const subTitleText = {
  fontWeight: "900",
};

const dividerStyle = {
  mt: 2,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const contentContainer = {
  p: 3,
  pt: 1,
  mt: 2,
  backgroundColor: Colors.grey100,
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const colorRed = {
  color: "red",
};

const mainContainer = {
  padding: 3,
  borderRadius: "20px",
  margin: {
    sm: 0,
    md: 4,
  },
  marginTop: {
    xs: 4,
    md: 0,
  },
};

const titleStyle = {
  textAlign: "center",
  fontWeight: "600",
};

const listImageContainer = {
  display: "flex",
  flexWrap: "wrap",
};

const imageCard = {
  m: "auto",
  mt: 2,
};

const cameraContainer = {
  mt: 2,
  mb: 2,
};

const cameraPreview = {
  width: "100%",
  maxWidth: "420px",
  borderRadius: "8px",
  backgroundColor: "#000",
};

const cameraButtonContainer = {
  display: "flex",
  flexWrap: "wrap",
  gap: 1,
};
